<template>
  <div v-if="!isProjectConfigurationPage" class="main-header">

    <div :class="{'name': true, 'ml5': isProjectPage}">
      <a v-if="isProjectPage" href="/analysis/projects" class="fal fa-long-arrow-left pr10"></a>
      <span style="cursor: pointer"  @click="verifyBaseHeader">{{baseHeader}} </span>
      <span style="cursor: pointer"  @click="verifyHeader">{{mainHeader}}</span>
      <span 
        v-tooltip="{
          content: `${$t('project.message.expired_on', { expiredFor })} ${expiredFor} ${isAdmin ? `- <a href='/clients/${clientId}/projects/${$route.params.project_uid}/edit' target='_blank'>${$t('project.message.view_project')}</a>` : ''}`,
          html: true,
          delay: { show: 0, hide: 1000 }
        }" 
        v-if="isExpired" 
        class="cursor-pointer badge rounded p-1 text-bg-danger mx-2 text-xs align-top"
        v-text="$t('project.message.expired')">
      </span>
      <span v-if="secondaryHeader">/ {{secondaryHeader}}</span>
    </div>

    <nav>
      <ul v-if="useWhatsappHeader">
        <li>
          <router-link
            :to='`/whats_app/contacts`' exact
            v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">{{$t('contact.contacts')}}</a>
          </router-link>
        </li>
        <li>
          <router-link
            :to='`/whats_app/contact_lists`' exact
            v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">{{$t('contact.contacts_lists')}}</a>
          </router-link>
        </li>
      </ul>

      <ul v-if="useMobileAppHeader">
        <li>
          <router-link
            :to='`/mobile_app/contacts`' exact
            v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">{{$t('mobile_app_contact.contacts')}}</a>
          </router-link>
        </li>
        <li>
          <router-link
            :to='`/mobile_app/contact_lists`' exact
            v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">{{$t('mobile_app_contact.contacts_lists')}}</a>
          </router-link>
        </li>
      </ul>

      <ul v-if="isProjectParentPage || isUserPermissionPage || isClientDataApiPage">
        <li>
          <router-link
            :to='`/analysis/projects`'
            v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">Projects</a>
          </router-link>
        </li>

        <li v-if="user.code_admin == true">
          <router-link
            :to='`/analysis/user-permissions`'
            v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">User Permissions</a>
          </router-link>
        </li>

        <li v-if="clientDataApiPermissions.view || clientDataApiPermissions.manage">
          <router-link
            :to='`/analysis/client-data-api`'
            v-slot="{ href, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">{{ $t('client_data_api.title') }}</a>
          </router-link>
        </li>
      </ul>

      <ul v-if="useProjectHeader">
        <li v-if="user.code_admin == true || user.permissions.view_groups_screens == true">
            <router-link
              :to='`/analysis/projects/${$route.params.project_uid}/tags`'
              v-slot="{ href, route, navigate, isActive }"
            >
              <a :href="href" :class="{ 'active': isActive }">Tags</a>
            </router-link>
        </li>
        <li v-if="user.code_admin == true || user.permissions.view_groups_screens == true">
            <router-link
              :to='`/analysis/projects/${$route.params.project_uid}/authors`'
              v-slot="{ href, route, navigate, isActive }"
            >
              <a :href="href" :class="{ 'active': isActive }">Authors</a>
            </router-link>
        </li>
        <li v-if="user.code_admin == true || user.permissions.view_coders_list == true">
            <router-link
              :to='`/analysis/projects/${$route.params.project_uid}/coders`'
              v-slot="{ href, route, navigate, isActive }"
            >
              <a :href="href" :class="{ 'active': isActive }">Coders</a>
            </router-link>
        </li>
        <!-- <li v-if="user.code_admin == true || user.permissions.view_articles_group_notes == true"> -->
        <li>
          <router-link
            :to='`/analysis/projects/${$route.params.project_uid}/groups`'
            v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">Groups</a>
          </router-link>
        </li>
        <li v-if="user.code_admin == true">
          <router-link
              :to='`/analysis/projects/${$route.params.project_uid}/sources`'
              v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">Sources</a>
          </router-link>
        </li>
        <li>
          <router-link
              :to='`/analysis/projects/${$route.params.project_uid}/queries`'
              v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">Queries</a>
          </router-link>
        </li>
        <li v-if="user.code_admin == true || user.permissions.edit_project_setup == true">
          <router-link
            :to='`/analysis/projects/${$route.params.project_uid}/configuration`'
            v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">Configuration</a>
          </router-link>
        </li>
        <li v-if="user.code_editor == true">
          <router-link
            :to='`/analysis/projects/${$route.params.project_uid}/files`'
            v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">Files</a>
          </router-link>
        </li>
        <li>
          <router-link
              :to='`/analysis/projects/${$route.params.project_uid}/rules`'
              v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">{{$t("queryRules.rule_title")}}</a>
          </router-link>
        </li>
        <li>
          <router-link
              :to='`/analysis/projects/${$route.params.project_uid}/autoassign`'
              v-slot="{ href, route, navigate, isActive }"
          >
            <a :href="href" :class="{ 'active': isActive }">Article Filtering Rules</a>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import i18n from '../i18n'

export default {
  props: {
    headerBaseName: String,
    headerPrimaryName: String,
    headerSecondaryName: String,
    clientId: Number,
    expiredFor: String,
    isExpired: Boolean,
    isAdmin: Boolean
  },
    watch: {
    '$route'(to, from) {
      if (to.path === '/analysis/projects') {
        this.isExpired = false;
      }
    }
  },
  computed: {
    useProjectHeader() {
      return (
        this.isProjectPage ||
        this.isCodersPage ||
        this.isGroupsPage || 
        this.isCoderProfilePage ||
        this.isArticlesByGroupPage ||
        this.isTagsPage ||
        this.isUsageReportTagsPage ||
        this.isAuthorsPage ||
        this.isSourcesPage ||
        this.isArticlesByTagPage ||
        this.isArticlesByAuthorPage ||
        this.isArticlesByCoderPage ||
        this.isQueriesPage ||
        this.isFilesPage ||
        this.isAssignmentRulesPage ||
        this.isArticlesBySourcesPage ||
        this.isAuditsPage ||
        this.isRulesEnginePage
      );
    },
    useWhatsappHeader() {
      return (
        this.isWhatsappContactListsPage || 
        this.isWhatsappContactsPage || 
        this.isWhatsappContactPage || 
        this.isWhatsappContactListPage || 
        this.isWhatsappContactListAddContactPage
      )
    },
    useMobileAppHeader() {
      return (
        this.isMobileAppContactListsPage || 
        this.isMobileAppContactsPage || 
        this.isMobileAppContactPage || 
        this.isMobileAppContactListPage || 
        this.isMobileAppContactListAddContactPage
      )
    },
    projectUid() {
      return this.$route.params.project_uid;
    },
    isProjectParentPage() {
      return this.$route.name == 'analysis-projects-'
    },
    isUserPermissionPage() {
      return this.$route.name == 'analysis-user-permissions-'
    },
    isClientDataApiPage() {
      return this.$route.name === 'analysis-client-data-api-'
    },
    isProjectPage() {
      return this.$route.name == 'project'
    },
    isCodersPage() {
      return this.$route.name == 'analysis-projects--project_uid-coders'
    },
    isArticlesByCoderPage() {
      return this.$route.name == 'coder-articles'
    },
    isArticlesByAuthorPage() {
      return this.$route.name == 'author-articles'
    },
    isGroupsPage() {
      return this.$route.name == 'analysis-projects--project_uid-groups'
    },
    isCoderProfilePage() {
      return this.$route.name == 'analysis-projects--project_uid-coders--coder_id-profile'
    },
    isArticlesByGroupPage(){
      return this.$route.name == 'group-articles'
    },
    isArticlesBySourcesPage(){
      return this.$route.name == 'source-articles'
    },
    isProjectConfigurationPage() {
      return this.$route.name == 'analysis-projects--project_uid-configuration'
    },
    isSourcesPage() {
      return this.$route.name == 'analysis-projects--project_uid-sources'
    },
    isTagsPage() {
      return this.$route.name == 'analysis-projects--project_uid-tags'
    },
    isUsageReportTagsPage() {
      return this.$route.name == 'analysis-projects--project_uid-tags-usage-report'
    },
    isAuthorsPage() {
      return this.$route.name == 'analysis-projects--project_uid-authors'
    },
    isFilesPage() {
      return this.$route.name == 'analysis-projects--project_uid-files'
    },
    isArticlesByTagPage(){
      return this.$route.name == 'tag-articles'
    },
    isQueriesPage() {
      return this.$route.name == 'analysis-projects--project_uid-queries'
    },
    isAssignmentRulesPage() {
      return this.$route.name == 'analysis-projects--project_uid-autoassign'
    },
    isAuditsPage() {
      return this.$route.name == 'analysis-projects--project_uid-audits';
    },
    isRulesEnginePage() {
      return this.$route.name == 'analysis-projects--project_uid-rules-';
    },
    isWhatsappContactsPage() {
      return this.$route.name === 'whatsapp-contacts';
    },
    isWhatsappContactPage() {
      return this.$route.name === 'whatsapp-contact';
    },
    isWhatsappContactListsPage() {
      return this.$route.name === 'whatsapp-contact-lists';
    },
    isWhatsappContactListPage() {
      return this.$route.name === 'whatsapp-contact-list';
    },
    isWhatsappContactListAddContactPage() {
      return this.$route.name === 'whatsapp-contact-list-add-contact';
    },
    isMobileAppContactsPage() {
      return this.$route.name === 'mobile-app-contacts';
    },
    isMobileAppContactPage() {
      return this.$route.name === 'mobile-app-contact-details';
    },
    isMobileAppContactListsPage() {
      return this.$route.name === 'mobile-app-contact-lists';
    },
    isMobileAppContactListPage() {
      return this.$route.name === 'mobile-app-contact-list';
    },
    isMobileAppContactListAddContactPage() {
      return this.$route.name === 'create-mobile-app-contact-list';
    },
    baseHeader() {
      return this.headerBaseName;
    },
    mainHeader() {
      return this.headerPrimaryName;
    },
    secondaryHeader() {
      return this.headerSecondaryName;
    },
    ...mapState({
      user: state => state.user.user.data,
      clientDataApiPermissions: state => state.clientDataApi.permissions
    })
  },

  mounted() {
    if (this.isProjectParentPage || this.isUserPermissionPage || this.isClientDataApiPage) {
      this.$store.dispatch('clientDataApi/getPermissions');
    }
  },

  methods: {
    verifyHeader() {
      if (this.projectUid) {
        window.location.href = "/analysis/projects/" + this.projectUid
        // return this.$router.push("/analysis/projects/" + this.projectUid);
      }
      else if (this.isWhatsappContactListPage) {
        window.location.href = "/whats_app/contact_lists/" + this.$route.params.id;
      }
      else if(this.isWhatsappContactPage) {
        window.location.href = "/whats_app/contacts/" + this.$route.params.id;
      }
      else if (this.isMobileAppContactListPage) {
        window.location.href = "/mobile_app/contact_lists/" + this.$route.params.id;
      }
      else if(this.isMobileAppContactPage) {
        window.location.href = "/mobile_app/contact_details/" + this.$route.params.id;
      }
    },
    verifyBaseHeader() {
      if (this.isProjectPage) {
        window.location.href = "/analysis/projects/";
      } else if (this.isWhatsappContactListsPage || this.isWhatsappContactListPage) {
        window.location.href = "/whats_app/contact_lists/";
      } else if (this.isWhatsappContactsPage || this.isWhatsappContactPage) {
        window.location.href = "/whats_app/contacts/";
      } else if (this.isMobileAppContactListsPage || this.isMobileAppContactListPage) {
        window.location.href = "/mobile_app/contact_lists";
      } else if (this.isMobileAppContactsPage || this.isMobileAppContactPage) {
        window.location.href = "/mobile_app/contacts";
      }
    },

    onSetHeaderBaseName: function(value) {
      this.headerBaseName = value;
    },

    onSetHeaderPrimaryName: function(value) {
      this.headerPrimaryName = value;
    },

    onSetHeaderSecondaryName: function(value) {
      this.headerSecondaryName = value;
    }
  }
}
</script>